import script from "./PandoraMenu2.vue?vue&type=script&setup=true&lang=js"
export * from "./PandoraMenu2.vue?vue&type=script&setup=true&lang=js"

import "./PandoraMenu2.vue?vue&type=style&index=0&id=d999d68c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d999d68c"]])

export default __exports__